import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, FieldArray, reset } from 'redux-form';
import RadioButtonField from '../../fields/RadioButtonField/RadioButtonField';
import { ADDTL_TAX_FEES_FORM } from '../../constants/formNames';
import AddFees from '../../fieldSets/AddFees/add-fees';
import AddTaxes from '../../fieldSets/AddTaxes/add-taxes';
import submitAddtlTaxFeesForm from '../../submit/submitAddtlTaxFeesForm';
import validateAddtlTaxFeesForm from '../../validate/validateAddtlTaxFeesForm';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

class AddtlTaxFeesForm extends Component {
  constructor (props) {
    super(props);

    this.state = {
      selectedInput: null
    };

    this.toggleSelected = this.toggleSelected.bind(this);
  }

  toggleSelected (e) {
    this.props.dispatch(reset(ADDTL_TAX_FEES_FORM));

    this.setState({
      selectedInput: e.target.value
    });
  }

  inputProps (value) {
    const input = {
      name: 'taxOrFee',
      type: 'radio',
      value,
      id: `radio-${value}`,
      onChange: this.toggleSelected
    };

    return input;
  }

  render () {
    const { selectedInput } = this.state;
    const { currency, addOnFeeValues, handleSubmit } = this.props;
    return (
      <form className="addtl-tax-fees-form" onSubmit={handleSubmit} data-testing-id="addtl-tax-fees-form">
        <div>
          <div className="flex header center">
            <FormattedMessage
              id="inbox.addtl_tax_fees_form.want_add"
              defaultMessage="I want to add:"
            />
          </div>
          <div className="flex center">
            <Field
              component={RadioButtonField}
              input={this.inputProps('tax')}
              name="taxOrFee"
              displayText={ this.props.intl.formatMessage({ id: 'inbox.addtl_tax_fees_form.tax', defaultMessage: 'Tax' }) }
            />
            <Field
              component={RadioButtonField}
              input={this.inputProps('fee')}
              name="taxOrFee"
              displayText={ this.props.intl.formatMessage({ id: 'inbox.addtl_tax_fees_form.fee', defaultMessage: 'Fee' }) }
            />
          </div>
          { 'fee' === selectedInput &&
            <div className="fees-section flex center">
              <FieldArray
                name="fees"
                currency={currency}
                component={AddFees}
                classnames="form-fields"
                addOnFeeValues={addOnFeeValues}
              />
            </div> }
          { 'tax' === selectedInput &&
            <div className="flex center">
              <div className="tax-section">
                <FieldArray
                  name="taxes"
                  component={AddTaxes}
                  classnames="form-fields"
                />
              </div>
            </div> }
        </div>
      </form>
    );
  }
}

AddtlTaxFeesForm.propTypes = {
  currency: PropTypes.string,
  addOnFeeValues: PropTypes.object,
  handleSubmit: PropTypes.func,
  intl: intlShape
};

const config = {
  form: ADDTL_TAX_FEES_FORM,
  onSubmit: submitAddtlTaxFeesForm,
  validate: validateAddtlTaxFeesForm
};

export default injectIntl(reduxForm(config)(AddtlTaxFeesForm));
